import { _ as _asyncToGenerator, a as _regeneratorRuntime } from './asyncToGenerator-9cc1acb2.esm.js';
import { g as getLivepeerProvider } from './getStream-6597fb67.esm.js';
import { g as getClient } from './client-5dc6700c.esm.js';
import { _ as _objectSpread2 } from './objectSpread2-04e3d2b4.esm.js';
import { a as defaultTranscodingProfiles } from './provider-c391b414.esm.js';

function watchLivepeerProvider(callback) {
  var client = getClient();
  var handleChange = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", callback(getLivepeerProvider()));
            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function handleChange() {
      return _ref.apply(this, arguments);
    };
  }();
  var unsubscribe = client.subscribe(function (_ref2) {
    var provider = _ref2.provider;
    return provider;
  }, handleChange);
  return unsubscribe;
}

function createAsset(args) {
  var provider = getLivepeerProvider();
  return provider.createAsset(args);
}

function getAsset(args) {
  var provider = getLivepeerProvider();
  return provider.getAsset(args);
}

function updateAsset(args) {
  var provider = getLivepeerProvider();
  return provider.updateAsset(args);
}

function getAssetMetrics(args) {
  var provider = getLivepeerProvider();
  return provider.getAssetMetrics(args);
}

function getPlaybackInfo(args) {
  var provider = getLivepeerProvider();
  return provider.getPlaybackInfo(args);
}

function createStream(args) {
  var _args$profiles;
  var provider = getLivepeerProvider();
  return provider.createStream(_objectSpread2(_objectSpread2({}, args), {}, {
    profiles: (_args$profiles = args === null || args === void 0 ? void 0 : args.profiles) !== null && _args$profiles !== void 0 ? _args$profiles : defaultTranscodingProfiles
  }));
}

function getStreamSession(args) {
  var provider = getLivepeerProvider();
  return provider.getStreamSession(args);
}

function getStreamSessions(args) {
  var provider = getLivepeerProvider();
  return provider.getStreamSessions(args);
}

function updateStream(args) {
  var provider = getLivepeerProvider();
  return provider.updateStream(args);
}

export { createStream as a, getAssetMetrics as b, createAsset as c, getPlaybackInfo as d, getStreamSession as e, getStreamSessions as f, getAsset as g, updateStream as h, updateAsset as u, watchLivepeerProvider as w };
